import React, { useEffect, useRef } from 'react'
import './style.css'

export default function Select({optionList, title, setInput, onFocusColor, onFocusOutColor}) {

    const sel = useRef(null);
    const tit = useRef(null);

    useEffect(() => {
        sel.current.addEventListener("focusin", onFocus);
        sel.current.addEventListener("focusout", onFocusOut);
    })

    function onFocus(){
        if(onFocusColor){
            tit.current.style.color = onFocusColor;
        }else{
            tit.current.style.color = "black";
        }
    }

    function onFocusOut(){
        //setInput(sel.current.value)
        //console.log(sel.current.value)
        if(onFocusOutColor){
            tit.current.style.color = onFocusOutColor;
        }else{
            tit.current.style.color = "gray";
        }
    }

  return (
    <div className='select-container'>
        <p className='title' ref={tit}>{title}</p>
        <select className='select' ref={sel} onChange={() => setInput(sel.current.value)}>
            {optionList}
        </select>
    </div>
  )
}
